import { create } from 'zustand'
import { persist } from 'zustand/middleware'

// Region + Currency only — deliberately NOT Language. Language is read/written
// via i18n.language / i18n.changeLanguage() directly (existing
// i18next-browser-languagedetector already owns that persistence); duplicating
// it here would create two sources of truth for the same value. See
// specs/029-footer-locale-switcher/research.md.
//
// setRegion and setCurrency never touch each other or i18n — that's the
// literal implementation of the "3 independent axes" constraint (FR-005).
interface LocalePreferenceState {
  region: string
  currency: string
  setRegion: (code: string) => void
  setCurrency: (code: string) => void
}

export const useLocalePreferenceStore = create<LocalePreferenceState>()(
  persist(
    (set) => ({
      region: 'US',
      currency: 'USD',
      setRegion: (code) => set({ region: code }),
      setCurrency: (code) => set({ currency: code }),
    }),
    {
      name: 'swim-locale-preference',
      partialize: (state) => ({ region: state.region, currency: state.currency }),
    }
  )
)
